module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-pad-y-1"
  }, [_c('div', {
    staticClass: "c-page--container"
  }, [_c('header', {
    staticClass: "c-article__head u-block u-relative u-marg-b-xxl"
  }, [_c('div', {
    staticClass: "u-marg-b-xs"
  }, [_c('div', {
    staticClass: "u-valign-middle u-color--gray-light t-text--sm t-lspacing--md u-uppercase u-inline-block u-marg-l-w1of9 u-w5of9 u-marg-l-0@md u-fit-w@md",
    domProps: {
      "innerHTML": _vm._s(_vm.formatDate(_vm.contentPage.head.date))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-w2of9 u-align-right u-hide@md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.share)
    }
  })]), _vm._v(" "), _c('div', [_c('h1', {
    staticClass: "t-h4 u-uppercase u-inline-block u-marg-l-w1of9 u-w5of9 u-valign-top u-marg-l-0@md u-fit-w@md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.head.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-w2of9 u-align-right u-valign-top  u-hide@md"
  }, [_c('app-btn-share', {
    attrs: {
      "type": "mail",
      "url": _vm.currentURL,
      "content": _vm.contentPage.share.mail,
      "size": "small"
    }
  }), _vm._v(" "), _c('app-btn-share', {
    staticClass: "c-news-share-icon",
    attrs: {
      "type": "facebook",
      "url": _vm.currentURL,
      "content": _vm.contentPage.share.facebook,
      "size": "small"
    }
  }), _vm._v(" "), _c('app-btn-share', {
    staticClass: "c-news-share-icon",
    attrs: {
      "type": "twitter",
      "url": _vm.currentURL,
      "content": _vm.contentPage.share.twitter,
      "size": "small"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "c-article__cover js-article-cover u-relative u-marg-x-auto u-overflow-h",
    class: [_vm.coverIsLoading ? 'is-loading' : '']
  }, [_c('img', {
    staticClass: "u-absolute u-pos-tl u-hide u-overlow-h u-opacity--0",
    staticStyle: {
      "width": "1px"
    },
    attrs: {
      "src": _vm.contentPage.cover,
      "alt": _vm.contentPage.title,
      "title": _vm.contentPage.title
    },
    on: {
      "load": function($event) {
        _vm._coverOnLoad()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-article__cover__image u-absolute u-pos-tl u-fit u-index--1",
    style: ({
      'background-image': 'url(' + _vm.contentPage.cover + ')',
      'background-size': 'cover',
      'background-position': '50% 50%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "c-article__cover__filter u-absolute u-pos-tl u-fit u-index--2 u-bg--black u-opacity--0"
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.contentPage.content) ? _c('div', {
    staticClass: "is-article--html-v2 c-html-text o-content u-relative u-marg-t-xxl u-marg-b-xxxl u-marg-x-auto u-color--gray-light js-article-content",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.content)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contentPage.more) ? _c('div', {
    staticClass: "c-article--more c-marg--before-footer u-relative"
  }, [(_vm.contentPage.more.title) ? _c('h2', {
    staticClass: "t-h4 u-marg-b-xxl u-uppercase u-marg-l-xs",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.more.title)
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.contentPage.more.list), function(news) {
    return _c('div', {
      staticClass: "c-article--more__column u-inline-block u-valign-top u-w1of3 u-w1of2@lg u-w1of1@md"
    }, [_c('app-resume', {
      key: news.key,
      staticClass: "u-marg-x-xs",
      attrs: {
        "show-category-and-date": false,
        "type": news.type,
        "category": _vm.getTypeById(news.type).name,
        "date": news.date,
        "link": _vm.getArticleUrlBySlug(news.slug),
        "cover": news.cover,
        "title": news.title,
        "text": news.resume,
        "footer": _vm.contentPage.more.more,
        "share": _vm.contentPage.share
      }
    })], 1)
  })], 2) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-article__cover__loader u-absolute u-pos-tl u-fit u-index--3 u-bg--gray-darkest"
  }, [_c('div', {
    staticClass: "c-article__cover__loader__mask u-absolute u-pos-center u-overflow-h"
  }, [_c('img', {
    staticClass: "c-article__cover__loader__mask__img u-absolute u-fit-w",
    attrs: {
      "src": require("../../../assets/loader/loader-sprite-map.png"),
      "alt": "Loader"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c6d5f71"}!./src/scripts/components/page-article/template.html
// module id = 926
// module chunks = 0